import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiConfigService, ApiServicesConfig} from './config.service';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {first, Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root',

})
export class LoginService {

  currentChainId = -1;
  currentBranchId = -1;

  subs: Subscription[] = [];


  constructor(private httpClient: HttpClient,
              @Inject(ApiConfigService) private config: ApiServicesConfig,
              private router: Router
  ) {
  }

  setChainId(chainId: number) {
    this.setLsItem('chainId', chainId.toString())
    this.currentChainId = this.getLsItem('chainId') ? Number(this.getLsItem('chainId')) : -1;
  }

  getChainId(): number{
    this.currentChainId = this.getLsItem('chainId') ? Number(this.getLsItem('chainId')) : -1;
    return this.currentChainId;
  }

  setBranch(branchId: number) {
    this.setLsItem('branchId', branchId.toString())
    this.currentBranchId = this.getLsItem('branchId') ? Number(this.getLsItem('branchId')) : -1;
  }

  getBranchId(): number {
    this.currentBranchId = this.getLsItem('branchId') ? Number(this.getLsItem('branchId')) : -1;
    return this.currentBranchId;
  }

  public getAuthUrl(){
    let token = this.getToken();
    return environment.apiUrl + '/api/auth?token=' + token;
  }

  public isAuthenticated() {
    console.log('isAuthenticated')
    let token = this.getToken();
    return this.httpClient.get<boolean>(this.getAuthUrl());
  }

  setLsItem(key: string, value: string){
    window.localStorage.setItem(key, value);
  }

  getLsItem(key: string): string{
    const item = window.localStorage.getItem(key);
    if (typeof item === 'string') {
      return item;
    }

    return '';

  }

  getToken(): string {
   return this.getLsItem('apiToken') ?? '';
  }


  public async isLoggedIn(){
    return new Promise<boolean>((resolve) => {
        let sub = this.isAuthenticated()
          .pipe(first())
          .subscribe(
            isLoggedIn => {
              resolve(isLoggedIn);
              if ( !isLoggedIn) {
                this.router.navigate(['/login']);
              }
            },
            () => {
              resolve(false);
            }
          );
    });
  }

  public setToken(token: string) {
    this.setLsItem('apiToken', token.toString());
  }

  public login(username: string, password: string) {
    return this.httpClient.post(
      environment.apiUrl + '/api/user/login',
      {
        username,
        password,
        client_app: 'HPB',
        platform: 'web'
      }
    );
  }

  logout(){
    localStorage.removeItem('apiToken');
    this.router.navigate(['/login']);
  }

}
